import { render } from "./menu.vue?vue&type=template&id=170de6c8&ts=true"
import script from "./menu.vue?vue&type=script&lang=ts"
export * from "./menu.vue?vue&type=script&lang=ts"

import "./menu.vue?vue&type=style&index=0&id=170de6c8&lang=scss"

import exportComponent from "/home/quangphuc/s-tech/admin-nhaongay/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__